export const INVITATION_HEADERS = [
    'Code',
    'SingleUse',
    'RewardResources',
    'InvitationReward',
    'Popup',
    'RewardAction',
    'Segment',
    'PolicyHolder',
    'Cohort',
    'InvitationMethod',
    'Onboarding',
    'JoinChallenges'
]

export const EMPTY_INVITE = {
    code: '',
    singleUse: false,
    rewardResources: '',
    invitationReward: '',
    popup: '',
    rewardAction: '',
    segment: '',
    policyHolder: false,
    cohort: '',
    invitationMethod: '',
    onboarding: '',
    joinChallenges: false
}

const EMPLOYEE_ATTRIBUTE_FIELDS = {
    policy_holder: { key: 'policyHolder', type: 'boolean' },
    source: { key: 'cohort', type: 'string' },
    invitation_method: { key: 'invitationMethod', type: 'string' },
    onboarding: { key: 'onboarding', type: 'string' },
    auto_join_challenges_on_register: { key: 'joinChallenges', type: 'boolean' }
}

function isTruthyEmployeeData(data) {
    return data === true || data === 1 || data === '1' || String(data).toLowerCase() === 'true'
}

function isTruthyFlag(value) {
    return value === true || value === 1 || value === '1' || value === 'true'
}

export function invitationToFormFields(invitation) {
    if (!invitation)
        return { ...EMPTY_INVITE }

    const fields = {
        ...EMPTY_INVITE,
        code: invitation.code || '',
        singleUse: isTruthyFlag(invitation.singleUse)
    }

    const attrs = invitation.invitationEmployeeAttributes
        || invitation.employeeAttributes
        || invitation.employee_attributes
        || []
    ;(Array.isArray(attrs) ? attrs : [attrs]).forEach((row) => {
        const name = row?.employeeAttribute?.name
        const mapping = name && EMPLOYEE_ATTRIBUTE_FIELDS[name]
        if (!mapping) return
        if (mapping.type === 'boolean')
            fields[mapping.key] = isTruthyEmployeeData(row.data)
        else
            fields[mapping.key] = row.data == null || row.data === '' ? '' : String(row.data)
    })

    const segments = invitation.invitationSegments || invitation.segments || []
    const firstSegment = (Array.isArray(segments) ? segments : [segments]).find(Boolean)
    if (firstSegment) {
        fields.segment = firstSegment.team?.name
            || firstSegment.team?.lc_name
            || ''
    }

    const reward = invitation.invitationReward
        || (Array.isArray(invitation.invitationRewards) ? invitation.invitationRewards[0] : null)
    if (reward) {
        const sameTagAsCode = reward.tag
            && invitation.code
            && String(reward.tag).toLowerCase() === String(invitation.code).toLowerCase()
        if (sameTagAsCode)
            fields.rewardResources = reward.rewardResources != null ? String(reward.rewardResources) : ''
        else
            fields.invitationReward = reward.tag || ''
    }

    const data = invitation.invitationData
    if (data) {
        fields.popup = data.popup?.tag || data.popupTag || ''
        fields.rewardAction = data.rewardAction?.tag || data.rewardActionTag || ''
    }

    return fields
}

export function csvEscape(value) {
    const text = value == null ? '' : String(value)
    if (/[",\n\r]/.test(text))
        return `"${text.replace(/"/g, '""')}"`
    return text
}

export function splitCsvLine(line) {
    const cols = []
    let current = ''
    let inQuotes = false
    for (let i = 0; i < line.length; i++) {
        const ch = line[i]
        if (inQuotes) {
            if (ch === '"') {
                if (line[i + 1] === '"') {
                    current += '"'
                    i++
                } else {
                    inQuotes = false
                }
            } else {
                current += ch
            }
        } else if (ch === '"') {
            inQuotes = true
        } else if (ch === ',') {
            cols.push(current)
            current = ''
        } else {
            current += ch
        }
    }
    cols.push(current)
    return cols
}

export function parseCsvObjects(csvText, headerToken) {
    if (!csvText || !String(csvText).trim())
        return []
    const lines = String(csvText).replace(/\r\n/g, '\n').split('\n').filter((line) => line.trim())
    if (!lines.length)
        return []
    const first = splitCsvLine(lines[0].replace(/^\uFEFF/, '')).map((col) => col.trim())
    const hasHeader = first[0] && first[0].replace(/^"|"$/g, '').toLowerCase() === headerToken.toLowerCase()
    const headers = hasHeader ? first.map((h) => h.replace(/^"|"$/g, '')) : INVITATION_HEADERS
    const dataLines = hasHeader ? lines.slice(1) : lines
    return dataLines.map((line) => {
        const cols = splitCsvLine(line)
        const row = {}
        headers.forEach((header, i) => {
            row[header] = cols[i] != null ? String(cols[i]).trim() : ''
        })
        return row
    })
}

export function invitationFieldsToObject(fields) {
    return {
        Code: String(fields.code || '').trim(),
        SingleUse: fields.singleUse,
        RewardResources: fields.rewardResources,
        InvitationReward: fields.invitationReward,
        Popup: fields.popup,
        RewardAction: fields.rewardAction,
        Segment: fields.segment,
        PolicyHolder: fields.policyHolder,
        Cohort: fields.cohort,
        InvitationMethod: fields.invitationMethod,
        Onboarding: fields.onboarding,
        JoinChallenges: fields.joinChallenges
    }
}

export function serializeInvitationObjects(objects) {
    const rows = objects.map((obj) =>
        INVITATION_HEADERS.map((header) => csvEscape(obj[header] ?? '')).join(',')
    )
    return [INVITATION_HEADERS.join(','), ...rows].join('\n')
}

export function buildInvitationCsv(fields, csvText) {
    const objects = []
    if (fields?.code && String(fields.code).trim())
        objects.push(invitationFieldsToObject(fields))
    objects.push(...parseCsvObjects(csvText, 'Code'))
    if (!objects.length)
        return ''
    return serializeInvitationObjects(objects)
}

export function parseInvitationCsv(csvText) {
    if (!csvText)
        return []
    return parseCsvObjects(csvText, 'Code')
}
